export const MARK_EVENT_CLOUD_MATURITY = [
  'f9dae490-32b4-4d07-8a8a-3efd36641810',
];

export const MARK_EVENT_OBUCHENIE_ADVANCED = [
  'a9f937b8-1208-41ea-9fd3-4a3e26e8dd65',
];

export const MARK_EVENT_CERTIFICATION_ADVANCED = [
  '4d4253f8-d218-43e9-87a5-1928aa4e2488',
];

export const MARK_EVENT_EDUCATION_EAB = [
  '63a13fc5-8742-4b07-bf8f-b4fd25118cc4',
];

export const MARK_EVENT_EDUCATION_EAE = [
  '4308b9f4-ed7d-44a8-86e7-b4d811b2d022',
];

export const MARK_EVENT_EDUCATION_MLSPACE = [
  'fd8ebb7b-401d-4be4-aa21-7c077f8f12e3',
];

export const MARK_EVENT_EDUCATION_PROFESSIONAL = [
  '1d9e4051-48d3-4dc7-b716-1bd1bd946d4b',
];

export const MARK_EVENT_ABOUT = ['1027d361-7480-4fb7-8809-3afe989d1675'];

export const MARK_EVENT_STRUKTURA_IT = ['2dc1fb29-8909-4d9c-a3b3-57d134e0bdf8'];

export const MARK_EVENT_ISSLEDOVANIE_CLOUD_TECH = [
  'c63582ce-5893-4a9a-9f14-2e2bc972aaa8',
];

export const MARK_EVENT_EDUCATION_EAP = [
  'db7dd134-3b07-4fe4-b2eb-9e5fbd1529e5',
];

export const MARK_EVENT_WANTRESULT = ['35085f3b-27bf-4d15-9013-b1c850e5f3f6'];

export const MARK_EVENT_COMPLETO = ['01953734-6711-75f6-92c0-ea02fd6dea4b'];

export const MARK_EVENT_COURSE_FOUNDAMENTALS_EVOLUTION = [
  '01917f1f-fc24-7056-b439-bc12ef7ac169',
];

export const MARK_EVENT_SERTIFICATION_FUNDAMENTALS = [
  '01917f1e-f1ef-7bc1-a72f-02ded65031a8',
];

export const MARK_EVENT_KURS_FUNDAMENTALS = [
  '01917f1c-0136-78cf-a15f-cbfd450a8059',
];

export const MARK_EVENT_ADDITIONAL_EVENT_MATERIALS = [
  '019232e4-9752-7be9-a346-f5a5d6a33d28',
];

export const MARK_EVENT_CREATIVE_THINKING = [
  '019348ba-a0dc-74ba-b4e7-5dd365255ff1',
];

export const MARK_EVENT_SERTIFICATSIYA_CLOUD_FUNDAMENTALS = [
  '019386f5-781c-72a7-8eb6-ec6bf9e2eddf',
];

export const MARK_EVENT_CUSTOMER_CENTRICITY = [
  '0194d04d-c3b2-7348-84c8-837f9e67f1fa',
];

export const MARK_EVENT_EVOLUTION_STACK = [
  '019547ca-b7c7-7cc6-a714-d5c3dffa5c41',
];

export const MARK_EDUCATION = ['019528a5-00a7-7189-9167-25fd84399499'];

export const MARK_OSNOVY_RABOTY = ['01974075-51a9-79fe-ac10-30def8a7bbce'];
